/** Build on the network. Only what exists is offered; the rest is marked planned. */
export function BuildPage() {
  return (
    <article className="prose">
      <h1>Build on it</h1>
      <p className="lead">The network is an open API. Reading needs no registration; writing needs only a DID that signs.</p>

      <h2>Open API, no registration</h2>
      <ul>
        <li>Every read is public: claims, vouches, anchors, the rail log, DID documents and their history.</li>
        <li>Every write is a JWS signed by a DID. There is no account to create and no API key.</li>
        <li>The contract is an OpenAPI 3.1 document: <a href="/openapi.yaml" data-testid="openapi-link">openapi.yaml</a>. This app's own client is generated from it.</li>
        <li>Every person DID's log and every key compromise declaration, as one public export: <code>GET /did/export</code>.</li>
        <li>Per-DID rate limits on writes: planned.</li>
      </ul>

      <h2>Exports, SDK, embed</h2>
      <ul>
        <li>A nightly signed export of the whole graph: planned.</li>
        <li>A verification SDK: planned. Until it ships, the browser code this app uses to recompute signatures (did:webvh, JWS, delegations, Merkle proofs) is the reference.</li>
        <li>An embed snippet for showing a claim on another site: planned.</li>
      </ul>

      <h2>Issuers</h2>
      <p>Organisations register through the QSeverse console, which provisions their DID and signing key and issues credentials, including AuthorisedAttester delegations for their reviewers.</p>
    </article>
  );
}
